function initHomeBlogCarousel() {
	const carousel = document.querySelector( '[data-home-blog-carousel]' );

	if ( ! carousel || ! ( 'IntersectionObserver' in window ) ) return;

	const mediaQuery = window.matchMedia( '(max-width: 760px)' );
	const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
	let hasPlayed = false;

	function playHint() {
		if ( hasPlayed || ! mediaQuery.matches || reduceMotion.matches || carousel.scrollWidth <= carousel.clientWidth ) {
			return;
		}

		hasPlayed = true;

		window.setTimeout( () => {
			carousel.scrollTo( { left: 44, behavior: 'smooth' } );

			window.setTimeout( () => {
				carousel.scrollTo( { left: 0, behavior: 'smooth' } );
			}, 560 );
		}, 320 );
	}

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					playHint();
					observer.disconnect();
				}
			} );
		},
		{
			rootMargin: '0% 0% -12% 0%',
			threshold: 0.35,
		}
	);

	observer.observe( carousel );
}

export default initHomeBlogCarousel;
